import { render, staticRenderFns } from "./EditZonePage.vue?vue&type=template&id=5fa811d6&"
import script from "./EditZonePage.vue?vue&type=script&lang=js&"
export * from "./EditZonePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports